module.exports = __webpack_public_path__ + "static/media/map coach station icon active.f9fda417.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/map coach station icon active.svg
// module id = 851
// module chunks = 0